import React, { useEffect, useState } from 'react'
import {
  Grid,
  Box,
  Typography, Checkbox,
  Divider
} from "@mui/material";
import CustomButton from '../../Components/Button/Button';
import ShareDialog from "../../Components/ShareDialog/ShareDialog"
import { useDispatch, useSelector } from 'react-redux';
import { AddGroup, AddUserInGroup, DeleteUserFromGroup, GetAdminGroups, GetUsersAndGroups } from '../../Reducers/dcoi';
import ConfirmationModel from "../../Components/Common/DeleteModel/DeleteModel"
import DropDown from '../../Components/Common/DropDown/DropDown';
import Spinner from '../../Components/Common/Spinner/Spinner';
import Toster from '../../Components/Common/Toster/Toster';
import GroupDialog from '../../Components/GroupDialog/GroupDialog';
import "./SitePermission.js";

function SitePermission() {
  const { AdminGroups, userAndGroup, inProgress } = useSelector(
    (state) => state.dcoi
  );
  const [message, setMessage] = useState();
  const [severity, setSeverity] = useState();
  const [alert, setAlert] = useState(false);
  const [isAddGroup, setIsAddGroup] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [viewModel, setViewModel] = useState(false);
  const [groupId, setGroupId] = useState(1);
  const isAllSelected = userAndGroup?.length > 0 && selectedRows.length === userAndGroup.length;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetAdminGroups());
  }, [])

  const [isOpen, setIsOpen] = useState(false)

  const AddNew = () => {
    setIsOpen(!isOpen)
  }

  const Submit = () => {
    setViewModel(true)
  }

  const openGroupInfo = (e) => {
    setGroupId(e)
    dispatch(GetUsersAndGroups({ groupid: e }))
  }

  const handleRowCheck = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleCheckAll = () => {
    if (userAndGroup?.length > 0) {
      setSelectedRows(isAllSelected ? [] : userAndGroup.map((row) => row.Id));
    }
  };

  const handleDelete = (event) => {
    if (event && !selectedRows.length) {
      setAlert(true);
      setMessage("Please Select atLeast One Row")
      setSeverity("error")
    } else {
      setViewModel(event);
    }

  }

  const handleChangeGroup = (e) => {
    openGroupInfo(e)
  }

  const SucessDelete = () => {
    dispatch(DeleteUserFromGroup({ UserId: selectedRows, GroupId: groupId })).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setSelectedRows([])
        setViewModel(!viewModel)
        setAlert(!alert)
        setMessage(res?.payload?.data[0]?.success)
        setSeverity("success");
        dispatch(GetUsersAndGroups({ GroupId: groupId }))
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setSeverity("error");
        setMessage(res?.payload?.data[0]?.error)
      } else {
        setAlert(true);
        setMessage("Something Went Wrong")
        setSeverity("error");
      }
    })
  }


  const HandleShare = (e) => {
    dispatch(AddUserInGroup(e)).then((res) => {
      if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
        setSelectedRows([])
        setIsOpen(!isOpen)
        setAlert(!alert)
        setMessage(res?.payload?.data[0]?.success)
        dispatch(GetUsersAndGroups({ GroupId: groupId }))
        setSeverity("success");
      } else if (res?.payload?.data[0]?.status === "error") {
        setAlert(true);
        setSeverity("error");
        setMessage(res?.payload?.data[0]?.error)
      } else {
        setAlert(true);
        setMessage("Something Went Wrong")
        setSeverity("error");
      }
    })
  }

  const HandleGroupAdd = (e) => {
    try {
      dispatch(AddGroup(e)).then((res) => {
        if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
          setAlert(!alert);
          setMessage(res?.payload?.data[0]?.success)
          setSeverity("success");
          setSelectedRows([])
          setIsAddGroup(!isAddGroup);
          dispatch(GetUsersAndGroups({ GroupId: groupId }));
          dispatch(GetAdminGroups());
        } else if (res?.payload?.data[0]?.status === "error") {
          setAlert(true);
          setSeverity("error");
          setMessage(res?.payload?.data[0]?.error)
        } else {
          setAlert(true);
          setMessage("Something Went Wrong")
          setSeverity("error");
        }
      })
    } catch {
      setAlert(true);
      setSeverity("error");
      setMessage(`Something went wrong..`)
    }
  };


  useEffect(() => {
    dispatch(GetUsersAndGroups({ GroupId: groupId }));
  }, [groupId])


  return (<>
    <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
    <ConfirmationModel open={viewModel} handleOpen={handleDelete} SucessDelete={SucessDelete} />
    {isAddGroup ? <GroupDialog isOpen={isAddGroup} onClose={() => setIsAddGroup(!isAddGroup)} handleGroupAdd={HandleGroupAdd} /> : ""}
    {isOpen ? <ShareDialog isOpen={isOpen} onClose={AddNew} handleShare={HandleShare} children={groupId} submitChange={Submit} /> : ""}
    <Box sx={{ padding: "10px 40px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: { xs: "column", sm: "row" }, // Stack on small screens, row on larger screens
          gap: { xs: 4, sm: 0 } // Adds spacing between elements on small screens
        }}
      >
        <Box sx={{ minWidth: "225px" }}>
          <Typography sx={{ fontWeight: "bold" }}>Select The Group Name</Typography>
          <DropDown value={groupId} options={AdminGroups} onChange={handleChangeGroup} />
        </Box>
        <Box sx={{ paddingTop: "35px" }}>
          <CustomButton onClick={() => setIsAddGroup(!isAddGroup)} label="+ Add Group" />
        </Box>

      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexDirection={{ xs: "column", sm: "row" }} // Stack vertically on small screens, row on larger screens
        sx={{ margin: "10px 0px", gap: "20px" }}
      >
        <Box>
          <CustomButton onClick={AddNew} label="+ Add User" /> &nbsp;&nbsp;
          <CustomButton label="Delete User" onClick={() => handleDelete(true)} />
        </Box>
      </Box>
      <Box sx={{ margin: "20px 0px" }}>
        {/* Header for Large Screens */}
        <Box sx={{ overflowX: "auto", width: "100%" }}> {/* Enables scrolling per row */}
        <Box sx={{ minWidth: "600px" }}> {/* Ensures structured content */}
        <Grid
          container
          spacing={0}
          alignItems="flex-start"
          my={2}
          sx={{
            fontWeight: "bold",
            color: "gray",
            padding: "0px 20px",
          }}
        >
          <Grid item xs={1} sm={1} md={1} >
            <Checkbox
              sx={{ padding: "0px 10px" }}
              checked={isAllSelected}
              onChange={handleCheckAll}
            />
          </Grid>
          <Grid item xs={5} sm={5} md={5}>
            USER NAME
          </Grid>
          <Grid item xs={6} sm={6} md={6}>
            JOB TITLE
          </Grid>
        </Grid>
        <Divider/>
        {userAndGroup.length > 0 ? (
          userAndGroup.map((item, index) => (<React.Fragment key={index}>
                <Grid
                  container
                  alignItems="flex-start"
                  sx={{
                    margin: "20px 0",
                    padding: "0px 20px",
                  }}
                >
                  {/* Checkbox */}
                  <Grid item xs={1} sm={1} md={1}>
                    <Checkbox
                      sx={{ padding: "0px 10px" }}
                      checked={selectedRows.includes(item.Id)}
                      onChange={() => handleRowCheck(item.Id)}
                    />
                  </Grid>

                  {/* User Name */}
                  <Grid item xs={5} sm={5} md={5}>
                    <Typography>{item.UserName}</Typography>
                  </Grid>

                  {/* Job Title */}
                  <Grid item xs={6} sm={6} md={6}>
                    <Typography>{item.JobTitle}</Typography>
                  </Grid>
                </Grid>
              <Divider />
              </React.Fragment>))
        ) : (
          <>
            {!inProgress && userAndGroup.length === 0 && (
              <Box sx={{ margin: "20px", textAlign: "center", color: "gray", fontStyle: "italic" }}>
                No Data Found...
              </Box>
            )}
            <hr className="customHr" />
          </>
        )}
        </Box>
        </Box>
      </Box>
      <Spinner isLoading={inProgress} />
    </Box>
  </>)
}

export default SitePermission